import {User}								from '../user/interface';
import {Device, PutDeviceData,
	AssignDevicesState, ApiDeviceState,
	ApiDeleteDeviceState,
	ApiGetMdmDevices}						from './interface';

import * as API								from '../../ressources/API';


export default {
	getDevicesApi: async (user: User) => {
		const response = await API.getDevices(user, false);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	assignDevices: async (data: AssignDevicesState) => {
		const result: Device[] = [];

		await Promise.all(data.devicesId.map(async (id) => {
			const apiData: PutDeviceData = {
				assignOnly: true,
				assign:     typeof(data.assignUser) === 'string' ? data.assignUser : data.assignUser?._id
			};

			const response = await API.putDevice(id, apiData, data.user);

			if (response && response.status)
				result.push(response.data);
		}));
		return result;
	},
	putDeviceApi: async (data: ApiDeviceState) => {
		if (!data.idDevice)
			return null;

		const response = await API.putDevice(data.idDevice, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	postDevice: async (data: ApiDeviceState) => {
		const response = await API.postDevice(data.data, data.user);
		if (!response || !response.status)
			return response;
		return response.data;
	},
	deleteDevice: async (data: ApiDeleteDeviceState) => {
		const response = await API.deleteDevice(data.idDevice, data.user);
		if (!response || !response.status)
			return null;
		return data.idDevice;
	},
	// MDM
	getMdmDevicesApi: async (data: ApiGetMdmDevices) => {
		const response = await API.getMdmDevices(data.name, data.user);
		if (!response || !response.status)
			return {name: data.name, value: []};
		return {name: data.name, value: response.data || []};
	}
};
